import { render } from "./OtpInput.vue?vue&type=template&id=fcbd3ca0&ts=true"
import script from "./OtpInput.vue?vue&type=script&lang=ts"
export * from "./OtpInput.vue?vue&type=script&lang=ts"

import "./OtpInput.vue?vue&type=style&index=0&id=fcbd3ca0&lang=css"

import exportComponent from "/builds/entersekt/repos/sdk-browser/saas-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__